import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

// Protect any route — redirects to /login if not logged in
export default function PrivateRoute({ children, adminOnly = false }) {
  const { currentUser, userProfile } = useAuth();

  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }

  // If adminOnly and user is not admin/superadmin → redirect to dashboard
  if (adminOnly && userProfile?.role !== "admin" && userProfile?.role !== "superadmin") {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}
